import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, Search } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { useAuth } from '../contexts/AuthContext';
export function NotFoundPage() {
  const navigate = useNavigate();
  const {
    user
  } = useAuth();
  const getDefaultRoute = () => {
    switch (user?.role) {
      case 'super_admin':
        return '/admin/dashboard';
      case 'ketua_chapter':
      case 'ketua_student_chapter':
        return '/chapter/dashboard';
      case 'komite_pusat':
        return '/committee/dashboard';
      case 'koordinator_acara':
        return '/events/manage';
      case 'bendahara':
        return '/finance/dashboard';
      default:
        return '/dashboard';
    }
  };
  return <div className="min-h-screen bg-white flex items-center justify-center px-4" data-id="element-4008">
      <div className="max-w-md w-full text-center" data-id="element-4009">
        {/* 404 Illustration */}
        <div className="mb-8" data-id="element-4010">
          <div className="relative" data-id="element-4011">
            <h1 className="text-9xl font-bold text-neutral-200" data-id="element-4012">404</h1>
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-4013">
              <Search className="w-24 h-24 text-neutral-400" data-id="element-4014" />
            </div>
          </div>
        </div>

        {/* Message */}
        <h2 className="text-2xl font-semibold text-neutral-900 mb-3" data-id="element-4015">
          Halaman Tidak Ditemukan
        </h2>
        <p className="text-neutral-600 mb-8" data-id="element-4016">
          Maaf, halaman yang Anda cari tidak ada atau telah dipindahkan.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-4017">
          <Button variant="secondary" onClick={() => navigate(-1)} className="flex items-center justify-center" data-id="element-4018">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-4019" />
            Kembali
          </Button>
          <Button onClick={() => navigate(getDefaultRoute())} className="flex items-center justify-center" data-id="element-4020">
            <Home className="w-4 h-4 mr-2" data-id="element-4021" />
            Ke Halaman Utama
          </Button>
        </div>

        {/* Help Text */}
        <p className="text-sm text-neutral-500 mt-8" data-id="element-4022">
          Butuh bantuan?{' '}
          <a href="mailto:support@atios.or.id" className="text-atios-primary hover:underline" data-id="element-4023">
            Hubungi Support
          </a>
        </p>
      </div>
    </div>;
}